/**
 * Main left column's class.
 *
 * Contains MainNavigationComponent at left and SubNavigationContainerComponent at right.
 * This class controls the switch between both components.
 *
 * SubNavigationContainerComponent contains two SubNavigationComponents. One at left and the other at right.
 * The first one is used to show and select main options, the right one is used to show and select secondary options like colors, etc.
 * SubNavigationContainerComponent component controls the switch between both sides.
 *
 * @Author: Jon Lucas
 * @Date:   2017-09-14T15:39:38+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-29T16:46:21+02:00
 */

import { Component, ViewChild, ChangeDetectionStrategy, Input } from "@angular/core";
import { Router, NavigationEnd, UrlTree } from "@angular/router";

import { trigger, state, group, style, animate, transition } from "@angular/animations";

import { AbstractComponent } from "../abstract-component/abstract.component";
import { MainNavigationComponent } from "./main-navigation/main-navigation.component";
import { SubNavigationComponent } from "./sub-navigation/sub-navigation.component";

import { BaseDataType } from "../base-data-type";

import { ServiceLocator } from "../service-locator";
import { AppService } from "../app.service";
import { ClassUtils } from "../util/ClassUtils";
import { AppLoadingStateService } from "../app-loading-state.service";
import { AfterViewInit } from "@angular/core/src/metadata/lifecycle_hooks";

type PaneType = "left" | "right";

@Component({
    selector: "app-main-left-column",
    templateUrl: "./main-left-column.component.html",
    styleUrls: ["./main-left-column.component.scss"],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger("slide", [
            state("left", style({ transform: "translateX(0)" })),
            state("right", style({ transform: "translateX(-50%)" })),
            transition("* => *", animate(300))
        ])
    ]
})

export class MainLeftColumnComponent extends AbstractComponent implements AfterViewInit {

    public readonly TAG: string = "[MainLeftColumnComponent]";

    @ViewChild(MainNavigationComponent) mainNavigation: MainNavigationComponent;
    @ViewChild(SubNavigationComponent) subNavigation: SubNavigationComponent;

    public activePane: PaneType = "left";

    protected router: Router;

    public showSubmenu: boolean = false;

    public lang: string;

    public typeId: string;
    public subtypeId: string;

    constructor(
        private appLoadingStateService: AppLoadingStateService
    ) {
        super();

        this.router = ServiceLocator.injector.get(Router);
        
        this.navigationEventHandler();
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(this.navigationEventHandler.bind(this));
    }

    protected navigationEventHandler(e: NavigationEnd = null): void {
        if(!(/^\/authentication\/.*$/.test(this.router.url))) {
            console.log(this.TAG, this.router.url, this.router.parseUrl(this.router.url));
            const urlTree: UrlTree = this.router.parseUrl(this.router.url);
            if (urlTree.root.children.primary === undefined) {
                return;
            }
            if(urlTree.root.children.primary.segments.length < 2) {
                return;
            }

            this.lang = urlTree.root.children.primary.segments[1] ? urlTree.root.children.primary.segments[1].path : undefined;
            this.typeId = urlTree.root.children.primary.segments[2] ? urlTree.root.children.primary.segments[2].path : undefined;
            this.subtypeId = urlTree.root.children.primary.segments[3] ? urlTree.root.children.primary.segments[3].path : undefined;

            let _showSM: boolean;
            switch (this.subtypeId) {
                case "roof-material":
                case "walls-material":
                case "project-type":
                case "profile-type":
                case "descente-type":
                case "roof-type":
                case "surelevation-type":
                case "belriv-type":
                    _showSM = true;
                    this.showSubmenu = true;
                    break;

                default:
                    _showSM = false;
                    // Time out to empty submenu's left pane after the transition
                    setTimeout(() => this.showSubmenu = _showSM, 300);
                    break;
            }
            this.activePane = _showSM ? "right" : "left";

            // Add hide-left-column to body for mobile display.
            this.subtypeId === undefined || this.subtypeId === "" || _showSM === true ? ClassUtils.removeClass(document.body, "hide-left-column") : ClassUtils.addClass(document.body, "hide-left-column");
        }
    }

    ngAfterViewInit(): void
    {
        this.appLoadingStateService.leftColumnLoaded = true;
    }

}



// WEBPACK FOOTER //
// ./src/app/main-left-column/main-left-column.component.ts